import React from 'react';
import './HeroFreeDesignMasjid.css';
import UseNewPage from '../../navigation/opennewpage/OpenNewPage';

const FreeDesignMasjid = ({ reverse = false }) => {

  return (
    <section className="fdm-section">
      <div className={`fdm-container ${reverse ? 'reverse' : ''}`}>
        <div className="fdm-visual">
          <div className="fdm-video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/S2oyA0q8fkQ?si=3kjOaLTTUAnhpLmf"
              title="Desain Masjid Gratis"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="fdm-content">
          <span className="fdm-badge">Program Khusus</span>
          <h2 className="fdm-title">
            <span className="highlight">Free Design Masjid</span> untuk Komunitas & Yayasan
          </h2>
          <p className="fdm-description">
            Dapatkan desain arsitektur masjid profesional secara gratis untuk komunitas Anda.
            Kami ingin mendukung pembangunan rumah ibadah yang indah, fungsional, dan representatif dengan nilai keberkahan.
          </p>
          <ul className="fdm-features">
            <li>✅ Desain arsitektur 3D modern</li>
            <li>✅ Dukungan teknis dan konsultasi</li>
            <li>✅ Gratis untuk komunitas & yayasan</li>
          </ul>
          <div className="fdm-buttons">
            <button className="btn primary" onClick={UseNewPage('/contact-us')}>Konsultasi Sekarang</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeDesignMasjid;
